import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { PageWrapper } from "../../Wrappers/PageWrapper/PageWrapper";
import { EmployeeBlockContainer as EmployeeBlock } from "Blocks/EmployeeBlock";
import { BlockContainer } from "BaseComponents/Wrappers";
import { OuterWrapper } from "../../../Blocks/EmployeeListBlock/EmployeeListBlock";
export const PageColumn = styled(PageWrapper).attrs(({}) => ({}))`
	& {
	}

	&:nth-of-type(1) {
		flex-basis: 20%;
		/* padding: 1rem 1rem 1rem 3rem; */
	}
	&:nth-of-type(2) {
		flex-basis: 80%;
		${media.lessThan(breakpoints.desktop)`
			padding-left: 0rem;
  		`};
	}
	${OuterWrapper}:first-of-type {
		padding-top: 0;
	}
`;
